const bonuses = [
  {
    icon: 'ri-line-chart-line',
    title: 'Accès à mon portefeuille en temps réel',
    desc: 'Vois exactement ce que je détiens, mes achats et mes ventes au fur et à mesure.',
  },
  {
    icon: 'ri-list-check-2',
    title: 'La liste des actions européennes',
    desc: 'Un référentiel complet des meilleures actions sur lesquelles se positionner selon la méthode LS INVEST.',
  },
  {
    icon: 'ri-discord-line',
    title: "Une communauté privée d'entraide sur Discord",
    desc: 'Rejoins la communauté, pose tes questions et avance avec d\'autres investisseurs motivés.',
  },
];

const BonusSection = () => (
  <section className="bg-white py-16 px-8 lg:px-16">
    <div className="max-w-[1272px] mx-auto">
      <div className="text-center mb-10">
        <h2 className="text-[#1E0750] font-black text-3xl lg:text-4xl">
          Avec des <span className="text-[#7B35ED]">bonus exclusifs</span>
        </h2>
        <p className="text-[#1E0750]/60 text-sm mt-3">En plus des 20 Modules Vidéos, tu accèdes à :</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {bonuses.map((b, i) => (
          <div key={i} className="bg-[#F5F0FF] border border-[#E2D9F3] rounded-2xl p-7 flex flex-col items-start gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-[#1E0750] rounded-xl">
              <i className={`${b.icon} text-[#A3E635] text-xl`} />
            </div>
            <h3 className="text-[#1E0750] font-bold text-base leading-snug">{b.title}</h3>
            <p className="text-[#1E0750]/60 text-sm leading-relaxed">{b.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default BonusSection;
